import { handleActions } from "redux-actions";
const initialState = [];
export default handleActions({ default: state => state }, initialState);
